import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  files: [],
  sharepoint: "",
  access_token: "",
  selectedOneDriveFiles: [],
  isFilesPicked: false,
};

export const oneDriveContent = createSlice({
  name: "oneDriveContent",
  initialState,
  reducers: {
    setFiles: (state, action) => {
      if (action.payload.type === "folder") {
        state.files = action.payload.files;
      } else {
        state.files = [...state.files, action.payload.file];
      }
    },
    setSharePoint: (state, action) => {
      state.sharepoint = action.payload;
    },
    setAccessToken: (state, action) => {
      state.access_token = action.payload;
    },
    setSelectedOneDriveFiles: (state, action) => {
      state.selectedOneDriveFiles = [
        ...state.selectedOneDriveFiles,
        action.payload,
      ];
    },
    resetOnedrive: (state, action) => {
      return initialState;
    },
    handleFilePicked: (state, action) => {
      state.isFilesPicked = action.payload;
    },
  },
});

export const {
  setFiles,
  setSharePoint,
  setAccessToken,
  setSelectedOneDriveFiles,
  resetOnedrive,
  handleFilePicked,
} = oneDriveContent.actions;
export default oneDriveContent.reducer;
